import React from 'react';
import { useTranslation } from './i18n.js';

const SUBSCRIPTION_STATUS_CONFIG = {
  SUBSCRIBED: { key: 'subscriptionStatusSubscribed', type: 'success' },
  ALREADY_SUBSCRIBED: { key: 'subscriptionStatusAlreadySubscribed', type: 'info' },
  GENERAL_ERROR: { key: 'subscriptionStatusGeneralError', type: 'error' },
};

export function SubscriptionStatusBanner() {
  const { t } = useTranslation();
  // `false` des deux côtés au premier rendu (le serveur ne connaît pas `window.location`) : lire
  // le vrai paramètre `?status=` dès le rendu client casserait l'hydratation si présent (bannière
  // apparaissant côté client mais absente du HTML serveur) — on le lit dans un effet à la place.
  const [status, setStatus] = React.useState(false);

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const statusParam = params.get('status');
    setStatus(statusParam ? statusParam.trim().toUpperCase() : false);
  }, []);

  const config = status && SUBSCRIPTION_STATUS_CONFIG[status];
  if (!config) {
    return null;
  }

  return (
    <div className={`subscription-status subscription-status--${config.type}`} role="status">
      {t(config.key)}
    </div>
  );
}
